export default __webpack_public_path__ + "static/B31-a9562c0c39790060e1963a2a5d18927a.png";